import {
  Button,
  CircularProgress,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";

import AppointmentForm from "./Appointmentform";
import { useForm } from "react-hook-form";
import Insuranceform from "./Insuranceform";
import Refferealsform from "./Refferealsform";
import { AppointmentformData } from "./fieldData";
import { encounterformType, insuranceType } from "../Type/EncounterTypes";
import moment from "moment";
import PatientDetails from "./PatientDetails";
import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { saveEncounter } from "../services";
import usePopup from "@hooks/usePopup";
import api from "@services/apiList";
import moduleRoutes from "@routes/moduleRouteList";
import PageRouterList from "@routes/routeList";
import { CustomFormField } from "@utilifiles/component/CustomFormElement";
import { EncounterContextv1 } from "..";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import {
  getReceptionPath,
  RECEPTION_TABS,
} from "@utilifiles/methods/navigation/receptionNavigation";

const base = (window as any)._env_?.BASE_URL;
function Encounterform() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { CustomModal, showSnackbar } = usePopup();
  const { id, idType, emrno } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const bookingId = queryParams.get("bookingId")
    ? parseInt(queryParams.get("bookingId") || "0")
    : null;
  const formControls = useForm();
  const { watch, control, handleSubmit, reset, setValue, getValues } = formControls;
  const [copay, setCopay] = useState([]);
  const context = useContext(EncounterContextv1);
  const [show, setShow] = useState(false);
  if (!context) {
    throw new Error(
      "EncounterComponent must be used within an EncounterProvider"
    );
  }
  const {
    // encounter,
    // insuranceId,
    encounterDetails,
    setEncounterDetails,
  } = context;

  const { clinicId } = api;
  const showAlert = (status: {
    severity: "success" | "error" | "warning";
    message: null | string;
  }) => {
    showSnackbar({
      message: status.message as string,
      variant: status.severity,
      open: true,
      duration: 3000,
    });
  };
  const navigateToReceptionEncounters = () => {
    navigate(getReceptionPath(RECEPTION_TABS.encounters));
  };

  const snackbarView = (data: any) => {
    // localStorage.removeItem(storageKey.encounterData)
    if (data == null) {
      showAlert({
        message: "Something went wrong",
        severity: "error",
      });
      return;
    }
    if (data == "success") {
      showAlert({
        message: "Encounter Updated Successfully",
        severity: "success",
      });
      setEncounterDetails(null);
      if (Boolean(bookingId)) {
        navigate(
          `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${PageRouterList.patientBooking}`,
        );
      } else if (location.state?.encounter) {
        navigateToReceptionEncounters();
      } else {
        navigate(-1);
      }
    } else if (data == "fail") {
      showAlert({
        message: "Encounter faild to update",
        severity: "error",
      });
    } else if (data == "no Patient") {
      showAlert({
        message: "choose patient before submit",
        severity: "error",
      });
    }
  };
  const { mutate: SaveOrUpdateEncounter, isLoading } = useMutation(
    saveEncounter,
    {
      onSuccess: () => {
        snackbarView("success");
        setShow(false);
      },
      onError: () => {
        snackbarView(null);
        setShow(false);
      },
    }
  );

  const onSubmit = (value: any) => {
    if (value.PaymentMode == 1) {
      setShow(true);
    } else {
      submit();
    }
  };
  const submit = () => {
    // console.log("getValues", getValues("visitPurpose"));
    // const policyValidityFrom = isNaN(moment(fromDate || null).year()) ? null : fromDate
    let insuraneId;
    let insuranceDetails: insuranceType;
    const formData = getValues()
    formData?.TPA?.id > 0
    ? (insuraneId = formData?.TPA?.id)
      : insuraneId = formData.Insurance?.id;
    let encounterId = emrno ? encounterDetails?.encounter?.encounterId : null;
    let id = emrno ? encounterDetails?.insurancePatient?.id : null;
    Boolean(bookingId) && (encounterId = null, id = null)
    // const existingEncounter = localStorage.getItem(storageKey.encounterData)
    const encounerDetails: encounterformType = {
      departmentId: formData.department?.departmentId || null,
      doctorId: formData.doctor?.doctorId,
      purposeId: formData.visitPurpose?.purposeId,
      referBy: formData.refferedby?.clcn_id || 0,
      referredBy: formData.refferedby?.clcn_name ,
      visitType: formData.visitType?.id || 0,
      knewAbout: formData.ReferenceSource?.type,
      postofficeId: formData.postofficeId?.poId,
      grouping: formData.grouping?.name,
      globalConsent: parseInt(formData.HIE),
      pMasterId: encounterDetails?.pmaster?.id,
      a28_msg_status: 0,
      encounterId,
      clinicId: clinicId,
      paymentMode: parseInt(formData.PaymentMode),
      createdByUserId: 1,
      id: 1
    }

    const body: { destination:string, clinicId: number, bookingId: number | null | undefined, pMaster: encounterformType, insurance?: insuranceType, copay?: any } = {
      clinicId,
      bookingId,
      destination:"Encountered",
      pMaster: encounerDetails
    }

    if (insuraneId > 0) {
      insuranceDetails = {
        id,
        insuranceType: formData.insuranceType?.id || null,
        insurance: formData.insuranceType?.id == 1 ? formData.TPA.id : formData.Insurance?.id,
        insuranceGroup: formData.InsuranceName?.id || null,
        insurancePlan: formData.InsurancePlan?.id || null,
        asopNo: formData.AsopNo || null,
        cardNo: formData.cardNumber || null,
        policyNo: formData.PolicyNumber || null,
        policyValidity: moment(formData.PolicyTill).format("YYYY-MM-DD"),
        policyValidityFrom: isNaN(moment(formData.PolicyFrom || null).year())
          ? null
          : formData.PolicyFrom,
        createdByUserId: 1,
        clinicId: clinicId,
        ip: "ip",
        paymentMode: parseInt(formData.PaymentMode),
        cardPhoto: "cardphoto.jpg",
        cardPhoto2: "cardphoto2.jpg",
      }
      body.insurance = insuranceDetails
      body.copay = copay
    };
    // console.log("encounter body => ",body)
    SaveOrUpdateEncounter(body)
  }




  const resetForm = () => {
    setEncounterDetails(null);
    reset();
  };

  const handleClick = () => {
    navigateToReceptionEncounters();
  };

  //  const  paymentChange=()=>{
  //     console.log(watch("PaymentMode"));
  //   }
  useEffect(() => {
    setValue("PaymentMode", 0);
  }, []);

  useEffect(() => {
    setValue("PaymentMode", encounterDetails?.encounter?.paymentMode || 0)
  }, [encounterDetails]);

  return (
    <div className="p-2 mt-2">
      <CustomModal open={show} setOpen={setShow} title="Copay/Deductable">
        <div className="w-[40vw] p-4 flex flex-col gap-2">
          Have you  entered copay and deductable ??
          <div className="flex justify-end gap-2">
            <Button
              color="error"
              variant="text"
              onClick={() => {
                setShow(false);
              }}
            >
              No
            </Button>
            <Button
              variant="text"
              onClick={submit}
              endIcon={isLoading && <CircularProgress size={20} />}
            >
              Yes
            </Button>
          </div>
        </div>
      </CustomModal>

      <Paper className="border p-2">
        <div className="col-span-full border-b-2 p-2 flex justify-between items-center">
          <Typography sx={{ color: "primary.main" }}>
            Encounter details
          </Typography>
          <Button
            endIcon={<FormatListBulletedIcon />}
            variant="outlined"
            onClick={handleClick}
          >
            Encounters
          </Button>
        </div>
        <PatientDetails formcontrol={formControls} />
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-2 gap-3 p-2"
        >
          <AppointmentForm formcontrol={formControls} />

          <div className="flex flex-col gap-4 content-between">
            <Refferealsform formcontrol={formControls} />

            <div className="relative pt-3 h-full">
              <Paper className="px-4 pt-4">
                <span
                  style={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.background.paper,
                  }}
                  className="absolute top-0 rounded px-2 left-3"
                >
                  Payment Type &nbsp;
                </span>
                <CustomFormField
                  control={control}
                  {...AppointmentformData.paymentType}
                />
              </Paper>
            </div>
          </div>

          <div className="col-span-full">
            {watch("PaymentMode") == 1 && (
              <Insuranceform formcontrol={formControls} SetCopay={setCopay} />
            )}
          </div>

          <div className="col-span-full w-full flex justify-between items-center gap-4 ">
            <div className="flex flex-row w-full gap-3 items-center justify-end">
              <Button disabled={isLoading} color="success" type="submit" endIcon={isLoading && <CircularProgress color={"success"} size={20} />}>
                Submit
              </Button>
              {!Boolean(id || idType || emrno) && (
                <Button color="error" onClick={resetForm}>
                  clear
                </Button>
              )}
            </div>
          </div>
        </form>
      </Paper>
    </div>
  );
}

export default Encounterform;
